export default "__VITE_ASSET__aOa1dMLW__"